import React from "react";
import { lang } from "../../../middleware/lang";

const ProductsRowList = ({ selectedCat, title, products, addFunction, tiggerAdded, selectedProductId }) => {
  const hasProducts = Object.keys(products).length > 0;
  const hiddenByCat = selectedCat !== null && !selectedCat;

  if (!hasProducts || hiddenByCat) return null;

  return (
    <div className="mb-2">
      <div
        style={{
          padding: "6px 12px",
          background: "#f5f5f5",
          borderLeft: "3px solid #FFBB28",
          marginBottom: 2,
        }}
      >
        <strong style={{ fontSize: 13, color: "#555", textTransform: "uppercase", letterSpacing: "0.5px" }}>
          {title}
        </strong>
      </div>
      {Object.keys(products)
        .sort((a, b) => (products[a].title || "").localeCompare(products[b].title || "", "es"))
        .map((key) => (
          <ProductListItem
            key={key}
            info={products[key]}
            addFunction={addFunction}
            tiggerAdded={tiggerAdded}
            isSelected={selectedProductId === products[key].id}
          />
        ))}
    </div>
  );
};

const ProductListItem = ({ info, addFunction, tiggerAdded, isSelected }) => {
  const isAdded = tiggerAdded === info.id;

  return (
    <div
      className={info.snoozed ? "" : "hover_pointer"}
      data-product_id={+info.id}
      onClick={info.snoozed ? undefined : addFunction}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px 12px",
        borderBottom: "1px solid #eee",
        background: isAdded
          ? "#fffbea"
          : isSelected
          ? "#fffdf0"
          : "#fff",
        outline: isSelected ? "2px solid #FFBB28" : "none",
        outlineOffset: "-2px",
        opacity: info.snoozed ? 0.45 : 1,
        transition: "background 0.2s",
      }}
    >
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 15, lineHeight: 1.2, marginBottom: info.snoozed ? 2 : 0 }}>
          {info.title}
        </div>
        {info.snoozed && (
          <small style={{ color: "#e53e3e" }}>
            <i className="fas fa-stopwatch mr-1" />
            {lang("Agotado", "Sold out")}
          </small>
        )}
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 10, flexShrink: 0 }}>
        <span style={{ fontWeight: 700, fontSize: 15, color: "#292929" }}>
          {info.has_size
            ? lang("Precio variable", "Variable price")
            : `$${info.price}`}
        </span>
        <div
          style={{
            width: 32,
            height: 32,
            borderRadius: "50%",
            background: isAdded ? "#48BB78" : "#FFBB28",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
            transition: "background 0.2s",
          }}
        >
          <i
            className={isAdded ? "fas fa-check" : "fas fa-plus"}
            style={{ fontSize: 13, color: "#292929" }}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductsRowList;
